enum BudgetTypes {
	LISTING = 'listing',
	CUSTOM = 'custom'
}

export { BudgetTypes };
